export default {
  getProcessPortal: {
    route: 'processPortal/processes/',
    method: 'get',
    select: 'id,name',
    orderBy: 'name',
  },

  getReportPortal: {
    route: 'processPortal/reports/',
    method: 'get',
    select: 'id,title',
    orderBy: 'title',
  },

  getPermissionPortal: {
    route: 'processPortal/allowedUsers/',
    method: 'get',
    select: 'id,fullName',
  },

  getPermissionPositions: {
    route: 'processPortal/allowedPositions/',
    method: 'get',
    select: 'id,name,description',
  },

  getPermissionAreas: {
    route: 'processPortal/allowedAreas/',
    method: 'get',
    select: 'id,name,description',
  },

  getPermissionUserGroups: {
    route: 'processPortal/allowedUserGroups/',
    method: 'get',
    select: 'id,name,description',
  },

  getListPortal: {
    route: 'processPortal/lists/',
    method: 'get',
    select: 'id,name',
    orderBy: 'name',
  },

  getEntityPortal: {
    route: 'processPortal/entities/',
    method: 'get',
    select: 'id,displayName',
    orderBy: 'displayName',
  },

  getMenuPortal: {
    route: 'processPortal/menuGroups/',
    method: 'get',
    select: 'id,title',
  },

  //Update
  updateProcessPortal: {
    route: 'processPortal/updateProcesses/',
    method: 'post',
  },

  updateReportPortal: {
    route: 'processPortal/updateReports/',
    method: 'post',
  },

  updateListPortal: {
    route: 'processPortal/updateLists/',
    method: 'post',
  },

  updateEntityPortal: {
    route: 'processPortal/updateEntities/',
    method: 'post',
  },

  updateMenuPortal: {
    route: 'processPortal/updateMenu/',
    method: 'post',
  },
};
